//don't add any newlines between the tick marks, otw you'll get a blank item in the bucket of texts
const letterText_ptbr = `A
Ã
Á
B
C
Ç
D
E
É
Ê
F
G
H
I
Í
J
K
L
M
N
O
P
Q
R
S
T
U
Ú
V
W
X
Y
Z`;
export default letterText_ptbr;
